export default __webpack_public_path__ + "static/avatar8-dc8a9b574e43f43ee2e3969c91107d45.png";